"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPortalsForBoxAdministration = exports["default"] = void 0;

var _reselect = require("reselect");

var _portal = require("./portal.actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var boxAdministrationPortalReducer = function boxAdministrationPortalReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _portal.FIND_PORTALS_FOR_ASSET_ALLOCATION_SUCCESS:
      {
        var portals = action.body.portals || [];
        var newState = portals.reduce(function (result, portal) {
          return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, portal.id, portal));
        }, {});
        return newState;
      }

    default:
      {
        return state;
      }
  }
};

var getPortalsForBoxAdministration = (0, _reselect.createSelector)(function (state) {
  return state.admin.boxes.portals;
}, function (portals) {
  return portals;
});
exports.getPortalsForBoxAdministration = getPortalsForBoxAdministration;
var _default = boxAdministrationPortalReducer;
exports["default"] = _default;